import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useSWR from 'swr';
import { fetcher } from '../../../helpers/processRequest';
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { setInventoriesList } from '../../../store/slices/inventorySlice';
import Search from 'antd/es/input/Search';

function ClassicInventoryList({ selectedProduct, setSelectedProduct, onAddToOrder }) {
    const dataFetcher = useSWR({ method: GET, url: API_ROUTE + '/inventories' }, fetcher);
    const inventories = useSelector(state => state.inventorySlice);
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        if (dataFetcher.data?.data) {
            dispatch(setInventoriesList(dataFetcher.data.data));
        }
    }, [dataFetcher.data?.data])

    const filteredData = () => {
        return inventories.inventoryList.filter(dt => dt.product?.name.toLowerCase().includes(searchText.toLowerCase()) || dt.barcode?.toLowerCase().includes(searchText.toLowerCase()));
    }

    // console.log(filteredData())

    const selectProduct = (item) => {
        setSelectedProduct(item);
    }

    return (
        <div>
            <Search placeholder='Search Products Here' onChange={(event) => setSearchText(event.target.value)} />
            <div className='max-h-10 overflow-y-auto' style={{ maxHeight: 300, height: 300 }}>
                <table className="min-w-full border-collapse border border-gray-300">
                    <thead className='sticky top-0 shadow-md'>
                        <tr className="bg-gray-100">
                            <th className="border border-gray-300 px-4 py-1 text-left text-sm">Name</th>
                            <th className="border border-gray-300 px-4 py-1 text-left text-sm">Selling Price</th>
                            <th className="border border-gray-300 px-4 py-1 text-left text-sm">Cost Price</th>
                            <th className="border border-gray-300 px-4 py-1 text-left text-sm">Discount</th>
                            <th className="border border-gray-300 px-4 py-1 text-left text-sm">Stock</th>
                            <th className="border border-gray-300 px-4 py-1 text-left text-sm">Category</th>
                            <th className="border border-gray-300 px-4 py-1 text-left text-sm">Supplier</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData().map((item, index) => (
                            <tr key={item.id} className={"cursor-pointer hover:bg-teal-500" + ` ${item.id === selectedProduct.id ? 'bg-teal-600' : ''}`} onClick={() => selectProduct(item)} onDoubleClick={() => onAddToOrder(item)}>
                                <td className="border border-gray-300 px-4 text-sm whitespace-nowrap">{item.product.name}</td>
                                <td className="border border-gray-300 px-4 text-sm">{item.price}</td>
                                <td className="border border-gray-300 px-4 text-sm">{item.costPrice}</td>
                                <td className="border border-gray-300 px-4 text-sm">{item.discount}</td>
                                <td className="border border-gray-300 px-4 text-sm">{item.stock}</td>
                                <td className="border border-gray-300 px-4 text-sm">{item.product.category.name}</td>
                                <td className="border border-gray-300 px-4 text-sm">{item.product?.supplier?.name}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ClassicInventoryList